import { render, staticRenderFns } from "./Component.vue?vue&type=template&id=c5316f36&scoped=true&"
import script from "./Component.vue?vue&type=script&lang=js&"
export * from "./Component.vue?vue&type=script&lang=js&"
import style0 from "./Component.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Component.vue?vue&type=style&index=1&id=c5316f36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5316f36",
  null
  
)

export default component.exports